module.exports = __webpack_public_path__ + "media/images/footer_reddit-493bbcd1e7446e03e6eb6758f497f704.png";